module.exports = __webpack_public_path__ + "img/hr-V-R-246-load-standup-base.98f42851.png";